import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CreditCard, Landmark } from 'lucide-react';
import {
  CREDIT_CARD_METHOD_ID,
  scheduledPaymentSentence,
  ScheduledPayment,
} from '@/utils/scheduled-payment';

interface Props {
  scheduledPayment: ScheduledPayment;
}

const ScheduledPaymentNote: FC<Props> = ({ scheduledPayment }) => {
  const { t, i18n } = useTranslation(['invoice-pay']);

  const { lead, rest } = scheduledPaymentSentence(
    scheduledPayment,
    (key, fallback, params) => t(key, fallback, params),
    i18n.language,
  );
  const Icon = scheduledPayment.method_type_id === CREDIT_CARD_METHOD_ID ? CreditCard : Landmark;

  return (
    <div className="mt-5 flex items-start gap-3 rounded-lg border p-3">
      <Icon aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
      <p className="text-sm">
        <span className="font-semibold">{lead}</span> {rest}
      </p>
    </div>
  );
};

export default ScheduledPaymentNote;
